import Constants from "@husky-hrc/Utilities/Constants";
import { enableHMRForChain } from "@husky-hrc/Utilities/Utilities";
import isApiError from "@insite/client-framework/Common/isApiError";
import { addToChainBefore, addToEndOfChain, ApiHandler, replaceInChain } from "@insite/client-framework/HandlerCreator";
import { API_URL_CURRENT_FRAGMENT, post, ServiceResult } from "@insite/client-framework/Services/ApiService";
import { AddProductApiParameter } from "@insite/client-framework/Services/CartService";
import {
    chain,
    ExecuteOnSuccessCallback,
    SendDataToApi,
} from "@insite/client-framework/Store/Pages/Cart/Handlers/AddToCart";
import { CartLineModel } from "@insite/client-framework/Types/ApiModels";

interface ExtendedAddToCartParameter extends AddProductApiParameter {
    shouldResetWishLists?: boolean;
}

enableHMRForChain(chain);

const cartsUrl = "/api/v1/carts";

type addToCartProps = Parameters<typeof SendDataToApi>[0];

type AddToCartParameter = ExtendedAddToCartParameter;

export const HuskySendDataToApi = async (props: addToCartProps) => {
    const result = await addProductWithResult(props.apiParameter);
    if (result.successful) {
        props.apiResult = result.result;
    } else {
        props.parameter.onError?.(result.errorMessage);
        return false;
    }
};

export async function addProductWithResult(parameter: AddProductApiParameter): Promise<ServiceResult<CartLineModel>> {
    const cartLine = {
        productId: parameter.productId,
        qtyOrdered: parameter.qtyOrdered,
        unitOfMeasure: parameter.unitOfMeasure,
        notes: parameter.notes,
        sectionOptions: parameter.sectionOptions,
    } as CartLineModel;

    try {
        const cartLineModel = await post(
            `${cartsUrl}/${API_URL_CURRENT_FRAGMENT}/cartlines?configId=${(parameter as any).configId}`,
            cartLine,
        );
        return {
            successful: true,
            result: cartLineModel,
        };
    } catch (error) {
        if (isApiError(error) && error.status === 400) {
            return {
                successful: false,
                errorMessage: error.errorJson.message,
            };
        }
        throw error;
    }
}

export const ResetWishListData: ApiHandler<ExtendedAddToCartParameter, CartLineModel> = props => {
    if (props.parameter.shouldResetWishLists) {
        props.dispatch({
            type: "Data/WishListLines/Reset",
        });
        props.dispatch({
            type: "Data/WishLists/Reset",
        });
    }
};

export const DispatchRemoveProductConfig = (props: addToCartProps) => {
    props.dispatch({
        type: Constants.Actions.RemoveProductConfig,
        productId: props.parameter.productId,
    } as any);
};

replaceInChain(chain, SendDataToApi, HuskySendDataToApi);
addToChainBefore(chain, ExecuteOnSuccessCallback, ResetWishListData);
addToEndOfChain(chain, DispatchRemoveProductConfig);
